import React, { useEffect } from 'react';
import { Link } from 'react-router-dom';
import { ChevronLeft } from 'lucide-react';

const TermsPage: React.FC = () => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <div className="min-h-screen bg-[#FFF7ED] font-sans text-gray-800 py-20 px-4 sm:px-6 lg:px-8">
      <div className="max-w-4xl mx-auto">
        <Link to="/" className="inline-flex items-center text-orange-600 hover:text-orange-700 font-medium mb-8 transition-colors">
          <ChevronLeft size={20} className="mr-1" />
          Back to Home
        </Link>
        
        <div className="bg-white rounded-3xl shadow-xl border border-orange-100 p-8 md:p-12">
          <h1 className="text-4xl font-bold font-heading mb-8 text-gray-900 border-b border-orange-100 pb-4">
            Terms & Conditions
          </h1>
          
          <div className="space-y-8 text-gray-600 leading-relaxed">
            <section>
              <h2 className="text-2xl font-bold text-gray-900 mb-4">1. Introduction</h2>
              <p>
                Welcome to DocSprintAI, a product by Baigen TechnoLabs. By accessing or using our website and services, you agree to be bound by these Terms & Conditions. If you do not agree with any part of these terms, you must not use our services.
              </p>
            </section>

            <section>
              <h2 className="text-2xl font-bold text-gray-900 mb-4">2. Description of Service</h2>
              <p>
                DocSprintAI is an AI-powered requirements engine designed to automate product documentation, including but not limited to Business Requirement Documents (BRD), Product Requirement Documents (PRD), User Stories, and Project Estimates.
              </p>
            </section>

            <section>
              <h2 className="text-2xl font-bold text-gray-900 mb-4">3. User Accounts</h2>
              <p>
                To access certain features of DocSprintAI, you may be required to create an account. You are responsible for maintaining the confidentiality of your account credentials and for all activities that occur under your account.
              </p>
            </section>

            <section>
              <h2 className="text-2xl font-bold text-gray-900 mb-4">4. Intellectual Property</h2>
              <p>
                The content, features, and functionality of DocSprintAI are owned by Baigen TechnoLabs and are protected by international copyright, trademark, and other intellectual property laws. Users retain ownership of the input data they provide, but grant DocSprintAI a license to use such data to provide and improve the services.
              </p>
            </section>

            <section>
              <h2 className="text-2xl font-bold text-gray-900 mb-4">5. Use of AI Output</h2>
              <p>
                DocSprintAI leverages advanced AI models to generate documentation. While we strive for accuracy, AI-generated content may contain errors or omissions. Users are responsible for reviewing and validating all output before use in professional or commercial settings.
              </p>
            </section>

            <section>
              <h2 className="text-2xl font-bold text-gray-900 mb-4">6. Prohibited Activities</h2>
              <p>
                You agree not to use DocSprintAI for any unlawful purposes, to transmit harmful code, or to interfere with the integrity or performance of the service. Reverse engineering or attempting to extract the underlying AI models is strictly prohibited.
              </p>
            </section>

            <section>
              <h2 className="text-2xl font-bold text-gray-900 mb-4">7. Termination</h2>
              <p>
                We reserve the right to terminate or suspend your account and access to the services at our sole discretion, without notice, for conduct that we believe violates these Terms or is harmful to other users or us.
              </p>
            </section>

            <section>
              <h2 className="text-2xl font-bold text-gray-900 mb-4">8. Limitation of Liability</h2>
              <p>
                In no event shall Baigen TechnoLabs be liable for any indirect, incidental, special, consequential, or punitive damages arising out of or in connection with your use of the service.
              </p>
            </section>

            <section>
              <h2 className="text-2xl font-bold text-gray-900 mb-4">9. Governing Law</h2>
              <p>
                These Terms shall be governed by and construed in accordance with the laws of the jurisdiction in which Baigen TechnoLabs is registered, without regard to its conflict of law provisions.
              </p>
            </section>

            <section>
              <h2 className="text-2xl font-bold text-gray-900 mb-4">10. Contact Us</h2>
              <p>
                If you have any questions about these Terms, please contact us at <a href="mailto:sales@baigenlabs.com" className="text-orange-600 hover:underline">sales@baigenlabs.com</a>.
              </p>
            </section>
          </div>
          
          <div className="mt-12 pt-8 border-t border-orange-100 text-sm text-gray-400">
            Last updated: March 11, 2026
          </div>
        </div>
      </div>
    </div>
  );
};

export default TermsPage;
